import {
  IModaliteInfo,
  IFormOverview,
  IFormInfoFocus,
  IFormInfoDetails,
  IFormInfoInscript,
  IFormInfo,
  IFormOption,
  IOptionInfo
} from './formation.i';
import { ISessionInfo } from '../session/session.i';
import { IDomain } from '../domain/domain.i';
import { MTypeOrmEnum } from '@argalis-apps/entities';

export class CModaliteInfo implements IModaliteInfo {
  id = 0;
  libelle = '';

  constructor(source?: IModaliteInfo) {
    if (source) {
      Object.assign(this, { id: source.id, libelle: source.libelle });
    }
  }
}

export class CFormOverview implements IFormOverview {
  id = 0;
  libelle = '';
  modalite = [0];
  duree = 0;
  description = '';
  nbSessions = 0;
  bParcours = false;

  constructor(source?: IFormOverview) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle,
        modalite: source.modalite,
        duree: source.duree,
        description: source.description,
        nbSessions: source.nbSessions,
        bParcours: source.bParcours
      });
    }
  }
}

export class CFormInfoFocus implements IFormInfoFocus {
  accroche = '';
  objectifs = '';
  public = '';

  constructor(source?: IFormInfoFocus) {
    if (source) {
      Object.assign(this, {
        accroche: source.accroche,
        objectifs: source.objectifs,
        public: source.public
      });
    }
  }
}

export class CFormInfoDetails implements IFormInfoDetails {
  title = '';
  content = '';

  constructor(source?: IFormInfoDetails) {
    if (source) {
      Object.assign(this, {
        title: source.title,
        content: source.content
      });
    }
  }
}

export class CFormInfoInscript implements IFormInfoInscript {
  groupe = '';
  duree = '';

  constructor(source?: IFormInfoInscript) {
    if (source) {
      Object.assign(this, {
        groupe: source.groupe,
        duree: source.duree
      });
    }
  }
}

export class CFormOption implements IFormOption {
  id = 0;
  libelle = '';
  subscribed = false;

  constructor(source?: IFormOption) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle,
        subscribed: source.subscribed
      });
    }
  }
}

export class CFormInfo implements IFormInfo {
  id = 0;
  libelle = '';
  domaine: IDomain = null;
  focus = new CFormInfoFocus();
  details: IFormInfoDetails[] = [];
  inscriptions = new CFormInfoInscript();
  sessions: ISessionInfo[] = [];
  downloadUri?: string;
  isParcours?: boolean;
  backgroundPictureUri?: string;
  optionInfo: IOptionInfo = new COptionInfo();

  constructor(source?: IFormInfo) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle,
        domaine: source.domaine,
        focus: new CFormInfoFocus(source.focus),
        inscriptions: new CFormInfoInscript(source.inscriptions),
        sessions: source.sessions ? [...source.sessions] : source.sessions,
        downloadUri: source.downloadUri,
        isParcours: source.isParcours,
        backgroundPictureUri: source.backgroundPictureUri,
        optionInfo: source.optionInfo
      });
      for (const dt of source.details) {
        this.details.push(new CFormInfoDetails(dt));
      }
    }
  }
}

export class COptionInfo implements IOptionInfo {
  maxOptions = 0;
  options: IFormOption[] = [];
  optionType: MTypeOrmEnum.ETypeOption;
  public get hasOptions(): boolean {
    return this.options && this.options.length > 0 && this.maxOptions > 0;
  }

  constructor(source?: IOptionInfo) {
    if (source) {
      Object.assign(this, {
        maxOptions: source.maxOptions,
        optionType: source.optionType,
        options: source.options ? [...source.options] : source.options
      });
    }
  }
}
